import { Directive, ElementRef, HostListener, Input } from '@angular/core';
import { NgbTooltip } from '@ng-bootstrap/ng-bootstrap';

/**
 * Text overflow directive.
 * @description Angular directive. Applied to input, accept only number from user input.
 */
@Directive({
  selector: '[apTextOverflow]'
})
export class TextOverflowDirective {

  @Input() apTextOverflow?: NgbTooltip;

  constructor(public el: ElementRef) {
    this.el = el;
  }

  /**
   * Bind to keydown event, accept or not the character inserted by user
   * @param event keydown event
   */
  @HostListener('mouseover', ['$event'])
  onKeyDown(event: MouseEvent): void {
    if (!event.target) {
      return;
    }

    const visibleWidth = this.el.nativeElement.clientWidth,
      contentWidth = this.el.nativeElement.scrollWidth;

    if (contentWidth > visibleWidth && this.apTextOverflow) {
      this.apTextOverflow.open();
    }

    event.preventDefault();
  }
}

